module.exports = __webpack_public_path__ + "img/geekWire.326116b5.png";